import { useConfirmAppointmentMutation } from "../../../../../../../api/appointments/useConfirmAppointmentMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useConfirmAppointment() {
  const { appointment } = useContext();

  const { mutateAsync, isLoading } = useConfirmAppointmentMutation({
    onError: () => {
      uiNotification.error(
        "Unable to update appointment confirmation status. Try again later.",
      );
    },
    onSuccess: () => {
      uiNotification.success(
        "Appointment confirmation status has been successfully updated.",
      );
    },
  });

  return {
    toggle: () => {
      return mutateAsync({
        appointmentId: appointment.id,
        isConfirmed: !appointment.isConfirmed,
      });
    },
    isLoading,
  };
}
